"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BalanceWithdrawDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const exchange_1 = require("@framework/exchange");
const styled_1 = require("@framework/styled");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const BalanceWithdrawDialog = (props) => {
    const { viewItem } = props;
    const [rows, setRows] = (0, react_1.useState)([]);
    const { fn, isLoading } = (0, react_hooks_1.useApiCall)(api => {
        return api.fetchJson({
            url: "/balances",
            data: {
                targetIds: [viewItem?.id],
                accounts: [viewItem?.template.contract.address],
            },
        });
    }, { success: false });
    (0, react_1.useEffect)(() => {
        if (!viewItem?.template?.contract?.address) {
            return;
        }
        setRows([]);
        void fn().then((json) => {
            setRows(json.rows);
        });
    }, [viewItem?.id, viewItem?.template?.contract?.address]);
    return ((0, jsx_runtime_1.jsx)(mui_page_layout_1.ProgressOverlay, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(styled_1.StyledListWrapper, { count: rows.length, isLoading: isLoading, children: rows.map(row => ((0, jsx_runtime_1.jsxs)(styled_1.StyledListItem, { children: [(0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { sx: { width: 0.6 }, children: row.token?.template?.title }), (0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { sx: { width: 0.4 }, children: (0, exchange_1.formatEther)(row.amount.toString(), row.token?.template?.contract?.decimals, row.token?.template?.contract?.symbol) })] }, row.id))) }) }));
};
exports.BalanceWithdrawDialog = BalanceWithdrawDialog;
//# sourceMappingURL=index.js.map